<ol class="breadcrumb">
    <breadcrumbs></breadcrumbs>
</ol>
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <wj-tab-panel [selectedIndex]="0">
                <wj-tab>
                    <a>分析</a>
                    <div class="card">
                        <div class="card-header">
                            分析
                        </div>
                        <div class="card-body">
                            <div class="form-group row">
                                <label class="col-md-3 form-control-label d-none d-lg-block">日付</label>
                                <div class="col-md-3">
                                    <wj-input-date #fromDateInput (valueChanged)="onChangeFromDate()"  style="width:100%;" style="width:100%;" [(value)]="fromDate"
                                                   [format]="'yyyy/MM/dd'" [isRequired]="false"
                                                   [placeholder]="'から'"></wj-input-date>
                                </div>
                                <div class="col-md-3">
                                    <wj-input-date #toDateInput style="width:100%;" style="width:100%;" [(value)]="toDate"
                                                   [format]="'yyyy/MM/dd'" [isRequired]="false"
                                                   [placeholder]="'まで'"></wj-input-date>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3 form-control-label d-none d-lg-block">検索</label>
                                <div class="col-md-3">
                                    <input type="text" [(ngModel)]="keyword" class="form-control" placeholder="検索">
                                </div>
                                <div class="col-md-3">
                                    <button (click)="search()" class="btn btn-primary btn-block">検索</button>
                                </div>
                                <div class="col-md-3">
                                    <button (click)="export('pivotGrid','計量集計')" class="btn btn-success btn-block">エクスポート</button>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-4">
                                    <wj-pivot-panel [itemsSource]="pivot"></wj-pivot-panel>
                                </div>
                                <div class="col-sm-8">
                                    <wj-pivot-grid  #pivotGrid [itemsSource]="pivot"></wj-pivot-grid>
                                </div>
                            </div>
                        </div>
                    </div>
                </wj-tab>
                <wj-tab>
                    <a>元データ</a>
                    <div class="card">
                        <div class="card-header">
                            元データ
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-sm-12">
                                    <wj-flex-grid #measureGrid [isReadOnly]="true" [selectionMode]="'Row'" style="height:500px" [itemsSource]="measures">
                                        <wj-flex-grid-filter></wj-flex-grid-filter>
                                        <wj-flex-grid-column [header]="'番号'" [binding]="'番号'" [width]="150"></wj-flex-grid-column>
                                        <wj-flex-grid-column [header]="'計量日'" [binding]="'計量日'" [width]="150"></wj-flex-grid-column>
                                        <wj-flex-grid-column [header]="'部門'" [binding]="'部門'" [width]="100"></wj-flex-grid-column>
                                        <wj-flex-grid-column [header]="'対象'" [binding]="'対象'" [width]="100"></wj-flex-grid-column>
                                        <wj-flex-grid-column [header]="'重量'" [binding]="'重量'" [width]="150"></wj-flex-grid-column>
                                        <wj-flex-grid-column [header]="'メモ'" [binding]="'メモ'" [width]="150"></wj-flex-grid-column>
                                    </wj-flex-grid>
                                </div>
                            </div>
                        </div>
                    </div>
                </wj-tab>
            </wj-tab-panel>
        </div>
    </div>
</div>
